import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterG = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M16.012 11.656H11.812V12.892H14.62C14.368 14.02 13.432 14.812 11.908 14.812C10.024 14.812 8.8 13.504 8.8 11.812C8.8 10.096 10.048 8.788 11.824 8.788C12.928 8.788 13.864 9.34 14.296 10.12L15.484 9.436C14.776 8.248 13.42 7.444 11.824 7.444C9.304 7.444 7.42 9.388 7.42 11.8C7.42 14.212 9.28 16.156 11.896 16.156C14.356 16.156 16.012 14.524 16.012 12.232V11.656Z" }),
});

export { IconCapitalLetterG };
